"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styling_1 = require("@uifabric/styling");
var utilities_1 = require("@uifabric/utilities");
var getStyles = utilities_1.memoizeFunction(function (theme, customStyles) {
    if (!theme) {
        theme = styling_1.getTheme();
    }
    var DefaultStyles = {
        root: {},
        header: {
            paddingTop: 8,
            paddingBottom: 0,
            paddingLeft: 16,
            paddingRight: 16
        },
        searchInputContainer: {
            selectors: {
                ".ms-SearchBox": {
                    backgroundColor: theme.palette.white
                }
            }
        },
        body: {},
        section: {
            marginTop: 16
        },
        sectionHeader: {
            marginLeft: 16
        },
        sectionTitle: Object.assign({}, theme.fonts.large, {
            fontWeight: styling_1.FontWeights.semibold
        }),
        sectionBody: {}
    };
    return styling_1.concatStyleSets(DefaultStyles, customStyles);
});
exports.getStyles = getStyles;
